import healthUnitSmartMappingDefinition, {
  recommendedSmartMappingOptions,
} from '../smartMapping/healthUnitSmartMapping.definition'
import healthUnitEditCoverageAreaDefinition from './healthUnitEditCoverageArea.definition'
import healthUnitFetchDefinition from '../fetch/healthUnitFetch.definition'
import { MultiPolygon, Polygon } from 'geojson'
import { EditCoverageArea } from '~/components/editCoverageArea'

interface HealthUnit {
  key: string
  cnes: string
  name: string
  latitude: number
  longitude: number
  coverageArea: Polygon | MultiPolygon | null
  kind:
    | 'smartMapping'
    | 'deprecated'
    | 'manualDrawing'
    | 'authorityProvided'
    | 'openStreetMapSourced'
    | null
}

const EditCoverageAreaScreen = EditCoverageArea<
  HealthUnit,
  typeof healthUnitFetchDefinition.input,
  typeof healthUnitFetchDefinition.output,
  typeof healthUnitEditCoverageAreaDefinition.input,
  typeof healthUnitEditCoverageAreaDefinition.output,
  typeof healthUnitSmartMappingDefinition.input,
  typeof healthUnitSmartMappingDefinition.output
>

export default function HealthUnitEditCoverageAreaScreen() {
  return (
    <EditCoverageAreaScreen
      editCoverageAreaDefinition={healthUnitEditCoverageAreaDefinition}
      fetchDefinition={healthUnitFetchDefinition}
      smartMappingDefinition={healthUnitSmartMappingDefinition}
      recommendedSmartMappingOptions={recommendedSmartMappingOptions}
    />
  )
}
